import { RegisterFormData } from "./types";

export const initialFormData: RegisterFormData = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  phone: "",
  birthDate: "",
  eventUpdates: false,
  promoOffers: false,
  textMessages: false,
  agreeToTerms: false,
  isEmployee: false, // Default value, typically this will be set by admins
};

export const passwordRequirements = [
  { text: "At least 8 characters", regex: /.{8,}/ },
  { text: "At least one uppercase letter", regex: /[A-Z]/ },
  { text: "At least one lowercase letter", regex: /[a-z]/ },
  { text: "At least one number", regex: /[0-9]/ },
  { text: "At least one special character", regex: /[!@#$%^&*(),.?":{}|<>]/ },
];
